export default __webpack_public_path__ + "static/media/CustomChamberEngageIcon.783d2305.png";